"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiHelp {
    static getAvailability(token, startDate, endDate, host) {
        let url = `/meetings/availability?startDate=${startDate}&endDate=${endDate}&host=${host}`;
        return Client_1.default.httpGet(url, token);
    }
    static scheduleMeeting(token, body) {
        let url = `/meetings/schedule`;
        return Client_1.default.httpPost(url, token, body);
    }
    static createCase(token, body) {
        let url = `/cases/create`;
        return Client_1.default.httpPost(url, token, body);
    }
}
exports.default = ApiHelp;
